import styled from "styled-components";

export const GNBContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 84px;
  padding: 24px 36px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(10, 20, 32, 0.60) 0%, rgba(10, 20, 32, 0.00) 100%);
  z-index: 1000;

  /* Mobile styles */
  @media (max-width: 768px) {
    height: 60px;
    padding: 0 16px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const SearchGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Divider = styled.div`
  width: 0;
  height: 24px;
  border-left: 1px solid rgba(141, 141, 141, 0.5);

  @media (max-width: 768px) {
    display: none;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const SettingsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Mobile: Hide auth buttons, only show CategoryMenu
export const AuthButtonsWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Mobile-only CategoryMenu wrapper (show on mobile, hide on desktop)
export const MobileCategoryMenu = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;
